module.exports = __webpack_public_path__ + "img/gallery-img-4.0024b43a.jpg";